module.exports = __webpack_public_path__ + "static/media/25.78d58d64.png";